import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import PropTypes from "prop-types";
import { Grid, Typography, Box } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import StatusCard from "./StatusCard";
import GridLoadingSpinner from "../GridLoadingSpinner/GridLoadingSpinner";
// import { ROUTES } from "../../constants";

const useStyles = makeStyles((theme) => ({
  section: {
    padding: theme.spacing(2),
    borderRadius: "20px",
    backgroundColor: "#ffffff",
    boxShadow: "0 0 10px rgba(0, 0, 0, 0.12)",
  },
  sectionTitle: {
    fontWeight: "bold",
    fontSize: "16px",
    color: "#00005C",
    marginBottom: "16px",
  },
  loader: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
}));

const STATUS_SEQUENCE = {
  RTA_APPROVED: 1,
  PERFORMER_APPROVED: 2,
  APPROVER_APPROVED: 3,
  EL_GENERATED: 4,
  SRN_UPDATE: 5,
  E_VERIFICATION: 6,
};

const transformApiDataToComponentFormat = (apiData) => {
  if (!apiData || !apiData.data) return [];

  return apiData.data
    .map((item) => {
      if (item.status === "INITIATED") return null;

      const { label } = item;
      const sequence = STATUS_SEQUENCE[item.status];

      if (!label || sequence === undefined) return null;

      return {
        label,
        value: item.count || 0,
        sequence,
        // route: STATUS_ROUTE_MAP[item.status] || "#",
      };
    })
    .filter(Boolean)
    .sort((a, b) => a.sequence - b.sequence);
};

const ApplicationStatus = ({ dashboardApiStatusData, loader }) => {
  const classes = useStyles();
  const history = useHistory();
  const [dashboardStatusData, setDashboardStatusData] = useState([]);

  useEffect(() => {
    const transformedRows = transformApiDataToComponentFormat(
      dashboardApiStatusData
    );
    setDashboardStatusData(transformedRows);
  }, [dashboardApiStatusData]); // Re-fetch when date filter changes


  return (
    <Grid item xs={12} className={classes.section}>
      <Typography variant="h6" className={classes.sectionTitle}>
        Application Status
      </Typography>
      {loader ? (
        <Box className={classes.loader}>
          <GridLoadingSpinner />
        </Box>
      ) : (
        <Grid container spacing={2}>
          {dashboardStatusData.map((item) => (
            <Grid item xs={12} sm={6} md={6} key={item.label}>
              <StatusCard {...item} history={history} />
            </Grid>
          ))}
        </Grid>
      )}
    </Grid>
  );
};
ApplicationStatus.propTypes = {
  dashboardApiStatusData: PropTypes.shape({
    data: PropTypes.arrayOf(PropTypes.object),
  }),
  loader: PropTypes.bool,
};

export default ApplicationStatus;
